'use client';

import { Maybe } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import { useEffect } from 'react';
import { tinaField } from 'tinacms/dist/react';
import '../styles/tokens.stylex';
import { borderRadius, color } from '../styles/tokens.stylex';
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";
export interface FullWidthMapProps {
  data?: {
    lat?: Maybe<number>;
    lng?: Maybe<number>;
    zoom?: Maybe<number>;
    [key: string]: unknown;
  };
}
export function FullWidthMap({
  data
}: FullWidthMapProps) {
  // Set the options for loading the API.
  const {
    lat,
    lng,
    zoom
  } = data || {};
  useEffect(() => {
    ;
    (async () => {
      setOptions({
        key: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string
      });
      const {
        Map
      } = await importLibrary('maps');
      const {
        AdvancedMarkerElement
      } = await importLibrary('marker');
      const map = new Map(document.getElementById('map') as HTMLElement, {
        center: {
          lat,
          lng
        },
        zoom,
        mapId: '881de6280134b89a',
        disableDefaultUI: true,
        tilt: 45
      });
      new AdvancedMarkerElement({
        map,
        position: {
          lat,
          lng
        },
        title: 'A&O 3PL Fulfilment and Direct Mail'
      });
    })();
  }, [lat, lng, zoom]);
  return data ? <div className="xrhgmaw x1dltgaz xt9rjjq x1skrob4 x14eurpq xb3r6kr x1n2onr6 x1basc5x x1q1flcd x1razraf x1qcoqpi x1by5hjz x1sfl7fc x1o5z2k8" data-tina-field={tinaField(data, 'lat')} id="map"></div> : null;
}